import { DateTime } from 'luxon';

import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

export class DashboardSummary {
  naturalId?: string;
  embedUrl?: string;
  vnextEmbedUrl?: string;
  vnextDefault?: boolean;
  vnextDeprecationDate?: DateTime;
  vnextMandatorySwitchDate?: DateTime;

  constructor(opts?: Partial<DashboardSummary>) {
    if (opts?.naturalId != null) {
      this.naturalId = opts.naturalId;
    }
    if (opts?.embedUrl != null) {
      this.embedUrl = opts.embedUrl;
    }
    if (opts?.vnextEmbedUrl != null) {
      this.vnextEmbedUrl = opts.vnextEmbedUrl;
    }
    if (opts?.vnextDefault != null) {
      this.vnextDefault = opts.vnextDefault;
    }
    if (opts?.vnextDeprecationDate != null) {
      this.vnextDeprecationDate = loadLuxonDateTime(opts.vnextDeprecationDate);
    }
    if (opts?.vnextMandatorySwitchDate != null) {
      this.vnextMandatorySwitchDate = loadLuxonDateTime(
        opts.vnextMandatorySwitchDate,
      );
    }
  }
}
